"use strict";
exports.__esModule = true;
exports.POPPER_CONTENT_POSITION = exports.POPPER_POSITION = void 0;
exports.POPPER_POSITION = {
    'bottom-left': '',
    'bottom': 'justify-center',
    'bottom-right': '',
    'top-left': '',
    'top': 'justify-center',
    'top-right': '',
    'left-start': '',
    'left': 'items-center',
    'left-end': '',
    'right-start': '',
    'right': 'items-center',
    'right-end': ''
};
exports.POPPER_CONTENT_POSITION = {
    'bottom-left': 'bottom-0 left-0 translate-y-full',
    'bottom': 'bottom-0 translate-y-full',
    'bottom-right': 'bottom-0 right-0 translate-y-full',
    'top-left': 'top-0 left-0 -translate-y-full',
    'top': 'top-0 -translate-y-full',
    'top-right': 'top-0 right-0 -translate-y-full',
    'left-start': 'left-0 -translate-x-full',
    'left': 'left-0 -translate-x-full',
    'left-end': 'bottom-0 left-0 -translate-x-full',
    'right-start': 'right-0 translate-x-full',
    'right': 'right-0 translate-x-full',
    'right-end': 'bottom-0 right-0 translate-x-full'
};
//# sourceMappingURL=popper.style.js.map